module.exports = __webpack_public_path__ + "static/media/ColumnNames.0e566ab0.svg";